function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useMemo } from 'react';
import { jsx } from 'react/jsx-runtime';
import { mergeProps, getTransition, safeCall } from '../utils/utils.js';
import { useBEM } from '../hooks/useBEM.js';
import { menuContainerClass, Keys, CloseReason } from '../utils/constants.js';
var MenuContainer = function MenuContainer(_ref) {
  var className = _ref.className,
    containerRef = _ref.containerRef,
    containerProps = _ref.containerProps,
    children = _ref.children,
    isOpen = _ref.isOpen,
    theming = _ref.theming,
    transition = _ref.transition,
    onClose = _ref.onClose;
  var itemTransition = getTransition(transition, 'item');
  var onKeyDown = function onKeyDown(_ref2) {
    var key = _ref2.key;
    switch (key) {
      case Keys.ESC:
        safeCall(onClose, {
          key: key,
          reason: CloseReason.CANCEL
        });
        break;
    }
  };
  var onBlur = function onBlur(e) {
    if (isOpen && !e.currentTarget.contains(e.relatedTarget)) {
      safeCall(onClose, {
        reason: CloseReason.BLUR
      });
    }
  };
  return /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({}, mergeProps({
    onKeyDown: onKeyDown,
    onBlur: onBlur
  }, containerProps)), {}, {
    className: useBEM({
      block: menuContainerClass,
      modifiers: useMemo(function () {
        return {
          theme: theming,
          itemTransition: itemTransition
        };
      }, [theming, itemTransition]),
      className: className
    }),
    style: _objectSpread({
      position: 'absolute'
    }, containerProps == null ? void 0 : containerProps.style),
    ref: containerRef,
    children: children
  }));
};
export { MenuContainer };